import React, { FC } from 'react'
import { Accordion as AccordionComponent } from '@ampdx/component-library/dist/components/Compounds/src/Accordion/index'

export type AccordionProps = {
  content: object
}

export const AccordionNextGen: FC<AccordionProps> = props => {
  const { content } = props

  return <AccordionComponent {...content} />
}
